<template>
  <div class="flex flex-row sm:flex-col sm:justify-center sm:text-center sm:space-y-3 mt-48 justify-between py-12 px-16 sm:px-12 w-full h-64 bg-BGcolor2 text-lg sm:text-base 2xl:text-xl font-bold text-white">
    <div class="flex flex-col">
      <p class="pb-5">Admins</p>
      <p>Borja, Faye Alexis D.</p>
      <p>Danabar, Mariane Vi E.</p>
      <p>Dela Cruz, Angelo V.</p>
      <p>Solosa, Kenneth Janry C.</p>
    </div>
    <div class="flex flex-col">
      <p class="pb-3">If you have any questions just email us at:</p>
      <div class="flex flex-row items-center space-x-2 sm:justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 rounded-lg text-white fill-current" viewBox="0 0 24 24"><path d="M0 3v18h24v-18h-24zm21.518 2l-9.518 7.713-9.518-7.713h19.036zm-19.518 14v-11.817l10 8.104 10-8.104v11.817h-20z"/></svg>
        <p>: physeekslight@gmail.com</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>